/* eslint-disable jsx-a11y/anchor-is-valid */

/* eslint-disable react/jsx-props-no-spreading */
import { useUrlGenerator } from '@folklore/routes';
import { useTracking } from '@folklore/tracking';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import useCategory from '../../hooks/useCategory';
import useFiltersQuery from '../../hooks/useFiltersQuery';
import useScrollEnter from '../../hooks/useScrollEnter';
import { usePageViewTracking } from '../../hooks/useTracking';

import { TaxonomyAdsTargetingProvider } from '../../contexts/AdsTargeting';
import { useGlobalBrand } from '../../contexts/LayoutContext';
import IndexDefaultHeader from '../headers/IndexDefaultHeader';
import InfiniteItemsBlocks from '../lists/InfiniteItemsBlocks';
import SortMenu from '../menus/SortMenu';
import NotFoundPage from './NotFoundPage';

import styles from '../../styles/pages/category-page.module.css';
import { useDefaultBrand } from '../../contexts/SiteContext';

const propTypes = {
    slug: PropTypes.string.isRequired,
    current: PropTypes.bool,
    className: PropTypes.string,
    contentClassName: PropTypes.string,
    onEnter: PropTypes.func,
    onLeave: PropTypes.func,
};

const defaultProps = {
    current: false,
    className: null,
    contentClassName: null,
    onEnter: null,
    onLeave: null,
};

function CategoryPage({ slug, current, className, contentClassName, onEnter, onLeave }) {
    const globalBrand = useGlobalBrand();
    const defaultBrand = useDefaultBrand();
    const url = useUrlGenerator();
    const { category = null, notFound = false } = useCategory(slug, {
        suspense: false,
    });
    const { id: categoryId = null, label, brand = null } = category || {};
    const finalBrand = brand || globalBrand || defaultBrand;
    const { handle: brandHandle = null } = finalBrand;
    const filters = useFiltersQuery();

    useScrollEnter({
        disabled: !current,
        onEnter,
        onLeave,
    });

    usePageViewTracking(current && category !== null, {
        brand,
        categories: [category],
        pageType: 'category',
    });

    if (notFound) {
        return <NotFoundPage current={current} />;
    }

    return (
        <TaxonomyAdsTargetingProvider taxonomy={category}>
            <div
                className={classNames([styles.container, className, contentClassName])}
                data-brand={brandHandle}
            >
                <IndexDefaultHeader
                    title={label}
                    placeholder={category === null}
                    className={styles.header}
                />
                <SortMenu
                    url={url('category', {
                        slug,
                    })}
                    className={styles.filters}
                />
                <main className={styles.content}>
                    <InfiniteItemsBlocks
                        query={{
                            category: categoryId,
                            ...filters,
                        }}
                        disabled={categoryId === null}
                        cardWithout={['category']}
                    />
                </main>
            </div>
        </TaxonomyAdsTargetingProvider>
    );
}

CategoryPage.propTypes = propTypes;
CategoryPage.defaultProps = defaultProps;

export default CategoryPage;
